<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li v-if="userDetail.id" class='breadcrumb-item active' aria-current='page'>{{ translations('shipping_instruction.warehouse_user_details') }}</li>
        <li v-else class='breadcrumb-item active' aria-current='page'>{{ translations('shipping_instruction.add_warehouse_user') }}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <form :class="wasValidated ? 'was-validated' : ''">
            <div class="form-group mb-3">
              <h6 class="font-weight-bold">{{ translations('shipping_instruction.company_name') }}</h6>
              <input
                :readonly="!isAdmin"
                type="text"
                v-model="userDetail.name"
                v-validate="'required'"
                data-vv-name="name"
                data-vv-as="会社名"
                class="form-control"
                required
              >
              <div class="invalid-feedback">
                {{ translations('shipping_instruction.company_name_required') }}
              </div>
            </div>
            <div class="form-group mb-3">
              <h6 class="font-weight-bold">{{ translations('shipping_instruction.email') }}</h6>
              <input
                :readonly="!isAdmin && !isWarehouseUser"
                type="text"
                v-model="userDetail.email"
                v-validate="'required'"
                data-vv-name="email"
                data-vv-as="メールアドレス"
                class="form-control"
                required
              >
              <div class="invalid-feedback">
                {{ translations('shipping_instruction.email_required') }}
              </div>
            </div>
            <div v-if="!userDetail.id || isWarehouseUser" class="form-group mb-3">
              <h6 class="font-weight-bold"><spac v-if="userDetail.id">{{ translations('shipping_instruction.new') }}</spac>{{ translations('shipping_instruction.password') }}</h6>
              <input
                type="password"
                v-model="userDetail.password"
                v-validate="'required'"
                data-vv-name="password"
                data-vv-as="パスワード"
                class="form-control"
                required
              >
              <div class="invalid-feedback">
                {{ translations('shipping_instruction.password_required') }}
              </div>
            </div>
            <div v-if="!userDetail.id || isWarehouseUser" class="form-group mb-3">
              <h6 class="font-weight-bold">{{ translations('shipping_instruction.reenter_password') }}</h6>
              <input
                type="password"
                v-model="userDetail.password_confirm"
                v-validate="'required'"
                data-vv-name="password_confirm"
                data-vv-as="パスワード"
                class="form-control"
                required
              >
              <div class="invalid-feedback">
                {{ translations('shipping_instrustion.reenter_password_required') }}
              </div>
              <div v-if="isInvalidPasswordConfirm" class="small text-danger">
                {{ translations('shipping_instruction.password_not_match') }}
              </div>
            </div>
            <div class="form-group mb-3">
              <h6 class="font-weight-bold">{{ translations('shipping_instruction.warehouse') }}</h6>
              <div v-for="(warehouse, i) in userDetail.warehouses" :key="i" class="form-inline justify-content-between">
                <span v-if="warehouse.id" class="form-control" style="border:none">
                  {{ warehouse.name }}
                </span>
                <span v-else>
                  <select class="form-control" v-model="userDetail.warehouses[i]">
                    <option v-for="(w, j) in masterWarehouses" :key="j" v-bind:value="w">
                      {{ w.name }}
                    </option>
                  </select>
                </span>
                <svg v-if="isAdmin" @click="removeWarehouse(i)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle text-danger" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </div>
              <div class="d-flex justify-content-end">
                <button v-if="isAdmin" type="button" class="btn btn-sm btn-info mt-3" v-on:click="addWarehouse">{{ translations('shipping_instruction.warehouse_addition') }}</button>
              </div>
            </div>
          </form>
          <hr>
          <div class="d-flex justify-content-between">
            <button v-if="userDetail.id" type="button" class="btn btn-primary" v-on:click="validateBeforeExecute">{{ translations('common.update') }}</button>
            <button v-else type="button" class="btn btn-primary" v-on:click="validateBeforeExecute">{{ translations('common.addition') }}</button>
            <button v-if="isAdmin && userDetail.id" type="button" class="btn-link text-danger" v-on:click="removeUser">
              {{ translations('shipping_instruction.delete_warehouse_user') }}</button>
          </div>
        </div>
      </div>
    </div>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'SingleWarehouseUsers',
  props: {},
  components: {
    VueElementLoading
  },

  data () {
    return {
      userId: 0,
      userDetail: {
        name: '',
        email: '',
        password: '',
        password_confirm: '',
        warehouses: []
      },
      isLoading: false,
      wasValidated: false
    }
  },

  created () {
    if (this.isAdmin) {
      this.$store.dispatch('Master/checkMywarehouses')
      if (this.$route.query.user_id) {
        // Update user.
        this.userId = this.$route.query.user_id
        this.getUser()
      }
    } else if (this.isWarehouseUser) {
      this.userId = this.$store.getters['WarehouseUser/id']
      this.getUser()
    }
  },

  mounted: function () {
  },
  computed: {
    ...mapState(['currentLanguage']),
    isAdmin: function () {
      return this.$store.getters['User/isAdmin']
    },
    masterWarehouses: function () {
      return this.$store.getters['Master/getMywarehouses']
    },
    isInvalidPasswordConfirm () {
      return this.userDetail.password !== this.userDetail.password_confirm
    },
    isWarehouseUser: function () {
      return this.$store.getters['WarehouseUser/isLogged']
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    validateBeforeExecute: function () {
      this.$validator.validateAll().then(response => {
        this.wasValidated = true
        if (this.isInvalidPasswordConfirm) return
        if (response === true) {
          if (this.userId) {
            this.updateUser().finally(() => { this.wasValidated = false })
          } else {
            this.addUser().finally(() => { this.wasValidated = false })
          }
        }
      }).catch(function (e) {
        // Catch errors
      })
    },

    getUser () {
      this.isLoading = true
      this.$http.post(this.$api_url.warehouse_user_detail, { user_id: this.userId }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.userDetail = {
            id: result.detail.id,
            name: result.detail.name,
            email: result.detail.email,
            warehouses: result.detail.warehouses
          }
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(e => {
        console.log('SingleWarehouseUsers:getUser:catch(error): ', JSON.stringify(e))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }).finally(() => {
        this.isLoading = false
      })
    },

    addWarehouse () {
      this.userDetail.warehouses.push({ id: '' })
    },

    removeWarehouse (index) {
      this.userDetail.warehouses.splice(index, 1)
    },

    addUser () {
      this.isLoading = true
      const params = {
        detail: this.userDetail
      }
      return this.$http.post(this.$api_url.warehouse_user_add, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.$toastr.success('倉庫ユーザーを追加しました。', 'Success')
          this.$router.replace('/archive-warehouse-users')
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(e => {
        console.log('SingleWarehouseUsers:addUser:catch(error): ', e)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }).finally(() => {
        this.isLoading = false
      })
    },

    updateUser () {
      this.isLoading = true
      const params = {
        user_id: this.userId,
        detail: this.userDetail
      }
      return this.$http.post(this.$api_url.warehouse_user_update, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.$toastr.success('ユーザー情報を更新しました。', 'Success')
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(e => {
        console.log('SingleWarehouseUsers:updateUser:catch(error): ', e)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }).finally(() => {
        this.isLoading = false
      })
    },

    removeUser () {
      this.$dialog.confirm('このユーザーを削除しますか?')
        .then(async () => {
          this.isLoading = true

          this.$http.post(this.$api_url.warehouse_user_remove, { user_id: this.userId }).then(response => {
            const result = response.data
            if (result.status === true) {
              this.$toastr.success('倉庫ユーザーを削除しました', 'Success')
              this.$router.replace('/archive-warehouse-users')
            } else {
              this.$toastr.error(result.message, 'エラー')
            }
          }).catch(e => {
            console.log('SingleWarehouseUsers:removeUser:catch(error): ', e)
            this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
          }).finally(() => {
            this.isLoading = false
          })
        }).catch(() => { console.log('Clicked `Cancel`') })
    }
  }
}
</script>
